import React, {ReactElement} from "react";
import {Grid} from "@components/grid/index";
import {IssuesResponse} from "@mwServices/Issue";
import GridPagination from "@components/grid/GridPagination";

interface IssueGridProps {
    isListGrid?: boolean;
    isLoading: boolean;
    className?: string;
    data?: IssuesResponse;
    paginationType?: number;
    onPaginationChange?: (page: number) => void;
    onPaginationSizeChange?: (current: number, perPage: number) => void;
    IssueRender: (props: IssueRenderProps) => ReactElement;
    expandedItem?: any;
    ExpandedRender?: (props: ExpandedRenderProps) => ReactElement;
    noDataMessage?: string;
    getItemProps: (item) => any;
}

export interface IssueRenderProps {
    item: any;
    filters?: any;
    onClick?: (issue, event?) => void;
    onIssueUpdate?: (issue) => void;
}

export interface ExpandedRenderProps {
    item: any;
    IssueRender: (props: IssueRenderProps) => ReactElement;
    onCloseClick?: () => void;
}

const IssueGrid = ({
    isListGrid,
    isLoading,
    className,
    data,
    paginationType,
    onPaginationChange,
    onPaginationSizeChange,
    expandedItem,
    ExpandedRender,
    IssueRender,
    noDataMessage,
    getItemProps,
}: IssueGridProps) => {
    return (
        <Grid
            isListGrid={!!isListGrid}
            className={className ? className : ''}
            loading={isLoading}
            dataSource={data ? data.issues : []}
            IssueRender={IssueRender}
            pagination={<GridPagination
                data={data}
                paginationType={paginationType}
                onPaginationChange={onPaginationChange}
                onPaginationSizeChange={onPaginationSizeChange}
            />}
            expandedItem={expandedItem}
            ExpandedRender={ExpandedRender}
            noDataMessage={noDataMessage}
            getItemProps={getItemProps}
        />
    );
};

export default IssueGrid;
